var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectMeetingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.786865,
    width: 30,
    height: 24,
    rx: 12,
    fill: "#0080FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_208_263",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 3,
    width: 19,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7869 3H6.78687V21H24.7869V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_208_263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4019 3.72986C12.7832 3.72986 10.647 5.87336 10.647 8.49204C10.647 10.0928 11.448 11.5112 12.667 12.3739C9.82369 13.5132 7.80664 16.2931 7.80664 19.537C7.811 19.7329 7.89192 19.9195 8.0321 20.0565C8.17229 20.1937 8.36057 20.2705 8.55665 20.2705C8.75272 20.2705 8.94101 20.1937 9.08118 20.0565C9.22136 19.9195 9.3023 19.7329 9.30664 19.537C9.30664 16.0944 12.0823 13.3202 15.5249 13.3202C16.7267 13.3202 17.842 13.6627 18.7915 14.2504C18.8756 14.3026 18.9691 14.3377 19.0668 14.3536C19.1644 14.3697 19.2643 14.3662 19.3606 14.3436C19.457 14.321 19.5479 14.2796 19.6283 14.2217C19.7085 14.1639 19.7766 14.0908 19.8287 14.0066C19.8806 13.9225 19.9156 13.8288 19.9313 13.7311C19.9471 13.6335 19.9435 13.5336 19.9206 13.4373C19.8977 13.341 19.8561 13.2501 19.7981 13.17C19.7401 13.0898 19.6668 13.0219 19.5825 12.9701C19.1547 12.7053 18.6903 12.498 18.2114 12.3198C19.3912 11.4525 20.164 10.0609 20.164 8.49204C20.164 5.87336 18.0206 3.72986 15.4019 3.72986ZM15.4019 5.23126C17.2098 5.23126 18.6641 6.68402 18.6641 8.49204C18.6641 10.3 17.2098 11.747 15.4019 11.747C13.5939 11.747 12.147 10.3 12.147 8.49204C12.147 6.68402 13.5939 5.23126 15.4019 5.23126ZM22.9927 14.2328C22.8708 14.2362 22.7515 14.2694 22.6454 14.3295C22.5392 14.3894 22.4492 14.4744 22.3833 14.577L19.7978 18.4516L18.1763 17.3661C18.094 17.3108 18.0017 17.2722 17.9046 17.2528C17.8074 17.2332 17.7074 17.233 17.6102 17.2523C17.513 17.2714 17.4206 17.3096 17.3381 17.3646C17.2557 17.4197 17.1849 17.4904 17.1299 17.5728C17.0748 17.6552 17.0366 17.7475 17.0175 17.8447C16.9982 17.9419 16.9983 18.0421 17.0179 18.1393C17.0373 18.2364 17.0759 18.3287 17.131 18.411C17.1863 18.4932 17.2573 18.5637 17.3398 18.6185L19.5942 20.1185C19.6763 20.173 19.7684 20.2108 19.8652 20.2297C19.9619 20.2486 20.0614 20.2481 20.158 20.2286C20.2545 20.209 20.3463 20.1706 20.4281 20.1154C20.5097 20.0604 20.5798 19.9898 20.6343 19.9077L23.6357 15.4061C23.714 15.2918 23.7591 15.158 23.7659 15.0195C23.7728 14.8812 23.7411 14.7435 23.6745 14.622C23.6079 14.5005 23.5089 14.3998 23.3886 14.331C23.2682 14.2623 23.1312 14.2283 22.9927 14.2328Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectMeetingIcon);
export default __webpack_public_path__ + "static/media/directMeetingIcon.c659f85c23c82644892259bc6dda4333.svg";
export { ForwardRef as ReactComponent };